module.exports = __webpack_public_path__ + "static/img/btn-bg.bfb5e1f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/limit-activity/btn-bg.png
// module id = z2b7
// module chunks = 216